
import { Section2,SectionTitle,SliderCard1, GradCard2 } from "../components/reuseable"
import Carousel from "../components/reuseable/carousel"

import { useAuth } from "../app/context";

const SpiritualJourney = () =>{

  let { isLoaded, spiritual, translations } = useAuth();
  
  return(
    <Section2 id="spiritual">
      <SectionTitle title={translations.spiritual.title} ts="3"/>

        {!!isLoaded && <div className="block-full my-48 p-1 pl-6 gradient-bc-3c-2 br-16 shadow-md text-italic">
          <div className="block-full bg-surface-1 color-accent fw-400 fs-18 lh-30 br-16 px-24 md:px-48 py-32 md:py-48">
            <span className="block-auto absolute top-10 left-16 md:left-24 color-highlight-2 text-left fs-48 md:fs-64 lh-none"
            style={{
              fontFamily: "serif",
              pointerEvents: "none",
            }}
          >"</span>
          {spiritual.quote || ""}
          </div>
        </div> } 

        {!!isLoaded && <Carousel
        dragable= {true}
        dots= {true}
        autoplay= {true}
        autoplayHoverPause= {true}
        autoplayTimeout= {4000}
        smartSpeed= {500}
        responsive= {{
          0 : {items: 1,margin:24},
          768 : {items: 2,margin:24},
          992 : {items: 3,margin:32},
        }}
      >
          {spiritual.items.map((item, index) => (
            <SliderCard1 className="gradient-bc-3 pt-8" key={index}>
              <div className="block-full mb-16  fs-32 lh-none">{item.emoji}</div>
              <div className="block-full mb-16 fw-600 fs-20 lh-30 font-inter color-header-2">{item.title}</div>
              <div className="block-full fw-400 fs-16 lh-24 font-inter color-soft">{item.description}</div>
            </SliderCard1>
          ))}
        </Carousel>}

        <div className="block-full my-16">&nbsp;</div>

        {!!isLoaded && <GradCard2 className="gradient-bc-3c-2 pt-6 sm:pt-8">
          <h3 className="block-full mb-16 fs-28 m:fs-32 lh-none font-inter fw-600 color-header-2 text-left">
            {spiritual.extras[0].emoji} {spiritual.extras[0].title}
          </h3>
          <div className="block-full fs-16 lh-24 font-inter color-soft text-justify">
            {spiritual.extras[0].description}
          </div>
          <hr className="block-full bw-1 bs-solid bc-muted opacity-20 my-16 md:my-24" />
          <h4 className="block-full mb-16 fs-24 lh-none font-inter fw-600 color-header-2 text-left">
            {spiritual.extras[1].emoji} {spiritual.extras[1].title}
          </h4>
          <div className="block-full fs-16 lh-24 font-inter color-soft text-justify">
            {spiritual.extras[1].description}
          </div>
        </GradCard2>}

    </Section2>
  )
}

export default SpiritualJourney;
